import React from 'react';
import { Plus } from 'lucide-react';
import { motion } from 'framer-motion';
interface FloatingActionButtonProps {
  onClick: () => void;
}
export function FloatingActionButton({
  onClick
}: FloatingActionButtonProps) {
  return <motion.button initial={{
    scale: 0,
    rotate: -180
  }} animate={{
    scale: 1,
    rotate: 0
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} onClick={onClick} className="fixed bottom-24 right-4 z-50 w-14 h-14 rounded-full bg-gradient-to-tr from-amber-600 to-amber-400 text-white shadow-lg shadow-amber-900/20 flex items-center justify-center" aria-label="Add Transaction" data-id="element-60">
      <Plus size={28} strokeWidth={2.5} data-id="element-61" />
    </motion.button>;
}